import { Suspense } from "react"
import { v4 as uuid } from "uuid"
import { useModals } from "web/hooks/modals"
import { Loading } from "web/components"
import { useFieldValue } from "web/hooks/data"

import Modal from "./Modal"

function RichTextModal({ fieldKey, record, readOnly, respond }) {
  const [fieldValue, { updateLocal }] = useFieldValue({
    subjectType: record.resource_type,
    topicId: record.topic_id,
    recordId: record.id,
    fieldKey,
  })

  const value = fieldValue.normalized?.value
  const source = fieldValue.source?.source

  async function handleSave(content) {
    const updatedFieldValue = { value: content, kind: "RichText" }

    const formattedUpdate = {
      [fieldKey]: {
        ...record.values[fieldKey],
        value: updatedFieldValue,
      },
    }

    const newLocalData = {
      ...record,
      values: { ...record.values, ...formattedUpdate },
    }

    updateLocal({ normalized: updatedFieldValue })

    record.update({ [fieldKey]: updatedFieldValue }, newLocalData)

    respond()
  }

  async function handleClear() {
    updateLocal({ normalized: null })

    await record.update({ [fieldKey]: null })

    record.refresh()

    respond()
  }

  return (
    <Modal
      trixEditorId={uuid()}
      readOnly={readOnly}
      value={value}
      source={source}
      handleSave={handleSave}
      handleClear={handleClear}
      disableAfterClick
    />
  )
}

function RichTextModalWrapper(props) {
  return (
    <div className="h-full">
      <Suspense fallback={<Loading inline />}>
        <RichTextModal {...props} />
      </Suspense>
    </div>
  )
}

export default function useAsyncRichTextModal({
  fieldKey,
  label,
  record,
  readOnly,
}) {
  const { showModal } = useModals()

  const defaultLabel = readOnly ? "View Rich Text" : "Edit Rich Text"

  return async function () {
    return await showModal({
      title: label || defaultLabel,
      fullScreen: false,
      heightPixels: 600,
      widthPixels: 800,
      component: ({ respond }) => (
        <RichTextModalWrapper
          fieldKey={fieldKey}
          record={record}
          readOnly={readOnly}
          respond={respond}
        />
      ),
    })
  }
}
